import { useContext } from 'react';

import MedicoInstitucion from './MedicoInstitucion';

import { saveInstitution } from '../../../actions/mainForm';
import { simpleConfirmDialog } from '../../../helpers/swal_msg';
import { form5Validator } from '../../../validators/MainFormValidator';

import useFetchHook from '../../../hooks/customHook';

import { DataContext } from '../../../context/DataContext';

import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const NewDialog = ({
    dialog4, institution, setInstitution, setDialogStatus,
    setDoctorInstitutions, setMedicos, institution_types
}) => {
    const { setData } = useContext(DataContext);
    const { protectedFetchReq } = useFetchHook();

    const handleClose = () => {
        setDialogStatus(e => ({ ...e, dialog2: true, dialog4: false }));
    };

    const saveFn = async () => {
        if (form5Validator(institution)) {
            if (await simpleConfirmDialog('¿Registrar institución?', 'Sí, registrar')) {
                await saveInstitution(
                    institution, setDoctorInstitutions, setMedicos, setDialogStatus, setData, protectedFetchReq
                );
            }
        }
    };

    return (
        <Dialog
            open={ dialog4 }
            onClose={ handleClose }
            aria-labelledby="new-dialog-title"
            aria-describedby="new-dialog-description"
            sx={{ zIndex: 1000 }}
        >
            <DialogTitle id="new-dialog-title">
                <IconButton
                    aria-label="close"
                    onClick={ handleClose }
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                Nueva Institución
            </DialogTitle>
            <DialogContent>
                <MedicoInstitucion
                    institution={ institution }
                    setInstitution={ setInstitution }
                    institution_types={ institution_types }
                    show_address={ false }
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={
                    () => setDialogStatus(e => ({ ...e, dialog2: false, dialog4: false }))
                }>
                    Salir
                </Button>
                <Button variant="contained" onClick={ saveFn }>
                    Registrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NewDialog;